import { useState } from 'react'
import { createRoute } from '@tanstack/react-router'
import rootRoute from './rootRoute'
import { $api } from '@/lib/fetch'
import { FilterPill, PageHeader, Row, spacing } from '@/components/ui'
import EntityCard from '@/components/EntityCard'

function EntitiesPage() {
  const { data: entitiesData, isLoading } = $api.useQuery(
    'get',
    '/api/entities',
  )
  const { data: kindsData } = $api.useQuery('get', '/api/entity-kinds')
  const [filterKind, setFilterKind] = useState<number | null>(null)

  const kinds = kindsData?.kinds ?? []
  const allEntities = entitiesData?.entities ?? []
  const entities = allEntities.filter(
    (e) => filterKind === null || e.kind_id === filterKind,
  )

  return (
    <div
      style={{
        maxWidth: 'var(--container-max)',
        margin: '0 auto',
        padding: 'var(--space-8) var(--gutter) var(--space-20)',
      }}
    >
      <PageHeader
        overline="Annuaire"
        title="Communautés"
        subtitle="Mosquées, associations et acteurs de la communauté musulmane en France."
        style={{ marginBottom: spacing.xl }}
      />

      <Row wrap gap="sm" style={{ marginBottom: spacing.xl }}>
        <FilterPill
          active={filterKind === null}
          onClick={() => setFilterKind(null)}
        >
          Tous ({allEntities.length})
        </FilterPill>
        {kinds.map((k: { id: number; name: string; emoji: string }) => {
          const count = allEntities.filter((e) => e.kind_id === k.id).length
          const active = filterKind === k.id
          return (
            <FilterPill
              key={k.id}
              active={active}
              onClick={() => setFilterKind(active ? null : k.id)}
            >
              {k.emoji} {k.name} ({count})
            </FilterPill>
          )
        })}
      </Row>

      {isLoading && <p style={{ color: 'var(--ink-2)' }}>Chargement…</p>}
      {!isLoading && entities.length === 0 && (
        <p style={{ color: 'var(--ink-2)' }}>Aucune entité trouvée.</p>
      )}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: 'var(--space-5)',
        }}
      >
        {entities.map((e) => (
          <EntityCard key={e.id} entity={e} kinds={kinds} />
        ))}
      </div>
    </div>
  )
}

export const entitiesPublicRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/communautes',
}).lazy(() => import('./EntitiesPage.lazy').then((m) => m.Route))

export default EntitiesPage
